import { AbstractControl, ValidationErrors } from '@angular/forms';
import { DateWrapperUtility } from 'src/app/presentation/shared/utilities/date-wrapper.utility';

export const dateTypeValidator =
  () =>
  (control: AbstractControl): ValidationErrors | null =>
    DateWrapperUtility.dateIsValid(control.value) ? null : { dateIsInvalid: 'Invalid date' };
